<mat-card id="main">
  <img src="assets/icons/AZ_logo_blue.PNG" style="width: 250px" class="right">
  <div layout="row" layout-align="start center">
    <section layout="row" layout-align="center center">
      <a mat-button color="primary" (click)="showUploadToolbar()" class="navigation">
        Paket Upload
        <div class="icon-wrapper">
          <mat-icon style="text-align: center;">file_upload</mat-icon>
        </div>
      </a>
      <!--      <a mat-button color="primary" class="isDisabled">Paket Statusanzeige<div class="icon-wrapper"><mat-icon style="text-align: center;">my_library_books</mat-icon></div>-->
      <!--        </a>-->
      <a mat-button color="primary" (click)="showStatusDisplayToolbar()" class="navigation isHidden">Paket Statusanzeige
        <div class="icon-wrapper">
          <mat-icon style="text-align: center;">my_library_books</mat-icon>
        </div>
      </a>
      <!--<a md-button color="primary" (click)="backToMaklerAllianz()" class="navigation ">Makler Portal<div class="icon-wrapper"><md-icon style="text-align: center;">reply_all</md-icon></div>-->
      <!--</a>-->
      <!--<a md-button color="primary" class="navigation ">Personendaten Download</a>-->
    </section>
  </div>
  <div class="mat-divider"></div>
  <div *ngIf="isUploadToolbar">
    <br>
    <p class="label-text_light_blue"><i>Diese Seite ist konzipiert für Makler, die ein oder mehrere Rahmenvereinbarungen
      über Privatpakete mit der Allianz geschlossen haben. Damit ist eine vollmaschinelle Übertragung der Vertragsdaten
      gewährleistet.<br>
      Sollten Sie kein Privatpaket mit der Allianz vereinbart haben, kann diese Seite nicht verwendet werden
    </i>
    </p>
  </div>
  <div class="mat-divider" *ngIf="isUploadToolbar"></div>
  <div class="div_middle">
    <div>
      <span class="label-text">Maklerpaket:</span>
      <div class="right">
        <select #selectElem (change)="chooseMaklerPaket(selectElem.value)">
          <option *ngFor="let maklerpacket of maklerPackets" [value]="maklerpacket.text">
            {{maklerpacket.text}}
          </option>
        </select>
      </div>
    </div>
    <div class="main_navigation" *ngIf="isUploadToolbar">
      <span class="label-text">Branche:</span>
      <div class="right">
        <select #selectElem (change)="chooseBranche(selectElem.value)" *ngIf="maklerPaket!=undefined">
          <option *ngFor="let gezeichneteProdukt of maklerPaket.gezeichneteProdukte"
                  [value]="gezeichneteProdukt.bezeichnung">
            {{gezeichneteProdukt.bezeichnung}}
          </option>
        </select>
      </div>
    </div>
  </div>

  <br/>
  <div class="main_navigation">
    <div class="div_after_middle" *ngIf="isUploadToolbar">
      <div>
        <input type="file" id="file" class="inputfile" (change)="changeListener($event.target.files)">
        <label for="file">File hinzufügen</label><span class="label-text"
                                                       *ngIf="isUploadToolbar&&isReadyForUpload">{{fileForUpload.name}}</span>
      </div>
      <div class="mini_top" *ngIf="isUploadToolbar&&isReadyForUpload">
        <a mat-button (click)="uploadFile()" class="mini-button">
          Upload Dateilieferung</a>
      </div>
    </div>
  </div>
  <br/>
  <div class="main_navigation" *ngIf="isStatusDisplayMainPage">
    <app-package-table [maklerPaketStatusInput]="maklerStatus"
                       (maklerPaketStatusEventEmitter)="loadProcessesTo($event)">
      Package-Table
    </app-package-table>
  </div>
  <div class="main_navigation" *ngIf="isStatusDisplayToolbar">
    <div style="margin-bottom:50px">
      <app-package-table [maklerPaketStatusInput]="maklerStatus"
                         (maklerPaketStatusEventEmitter)="loadProcessesTo($event)">
        Package-Table
      </app-package-table>
    </div>
    <div class="div_middle_status">
      <div>
        <h3 class="label-text">Zeitraum für Statusinformationen</h3>
      </div>
      <div>
        <span class="label-text">Lieferung von:</span>
        <div class="right">
          <p-calendar [(ngModel)]="lieferungVon" dateFormat="yy-mm-dd"></p-calendar>
        </div>
      </div>
      <br/>
      <div>
        <span class="label-text">Lieferung bis:</span>
        <div class="right">
          <p-calendar [(ngModel)]="lieferungBis" dateFormat="yy-mm-dd"></p-calendar>
        </div>
      </div>
      <div class="mini_top_10">
        <a mat-button color="warn" (click)="loadProcessesTo()" class="mini-button">Status Anzeige
          <!--        <div class="icon-wrapper">-->
          <!--          <mat-icon style="text-align: center;">border_inner</mat-icon>-->
          <!--        </div>-->
        </a>
      </div>
    </div>
    <br>

    <br/>
    <app-process-table [detailsInput]="maklerPaketStatusDetails" [von]="lieferungVon" [bis]="lieferungBis">
      Process-Table
    </app-process-table>
  </div>


</mat-card>
<!--<a href="" class="mini right margin_right" style="margin-top: 20px;">Aktuelle Hinweise</a>-->

<div *ngIf="errorOccurredWhileLoadingData" class="error-message-container">
  <div class="error-message">
    <h2>Ein fehler beim Laden der Daten ist aufgereten</h2>
  </div>
</div>
